import React from "react";
import StatsChart from "./components/StatsChart";
import OddsList from "./components/OddsList";

function App() {
  return (
    <div>
      <h1>NBA and MLB Team Performance</h1>
      <h2>NBA Team Stats</h2>
      <StatsChart league="NBA" />
      <StatsChart league="NBA" />
      
      <h2>MLB Team Stats</h2>
      <StatsChart league="MLB" />
      <StatsChart league="MLB" />

      <OddsList league="NBA" />
      {/* <OddsList league="MLB" /> */}

    </div>
  );
}

export default App;
